import { render, staticRenderFns } from "./searchOriginal.vue?vue&type=template&id=88f6b160&scoped=true&"
import script from "./searchOriginal.vue?vue&type=script&lang=js&"
export * from "./searchOriginal.vue?vue&type=script&lang=js&"
import style0 from "./searchOriginal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./searchOriginal.vue?vue&type=style&index=1&id=88f6b160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f6b160",
  null
  
)

export default component.exports